import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const Header = styled.div`
  background: ${({ theme }) => theme.palette.itemTypeColors.slide};
  padding: ${({ theme }) => theme.spacing.small} ${({ theme }) => theme.spacing.default};
  flex-shrink: 0;
  border: none;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.palette.white};
  font-weight: 700;
  margin-bottom: 4px;

  svg {
    font-size: 16px;
  }
`;

const HeaderTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.small};
  margin-bottom: 4px;
  flex-wrap: wrap;
`;

const HeaderSubtitle = styled.div`
  font-size: 10px;
  opacity: 0.88;
  color: rgba(255, 255, 255, 0.75);

  strong {
    font-weight: 600;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: ${({ theme }) => theme.spacing.small};
`;

const HeaderTabs = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;
`;

interface AiAssistantHeaderProps {
  title: string;
  subtitleSlot?: ReactNode;
  buttonSlot?: ReactNode;
  actionsSlotSlot?: ReactNode;
  tabsSlot?: ReactNode;
}

export const AiAssistantHeader: FC<AiAssistantHeaderProps> = ({
  title,
  buttonSlot,
  subtitleSlot,
  actionsSlotSlot,
  tabsSlot,
}) => {
  return (
    <Header>
      <HeaderTopRow>
        <HeaderTitle>
          <AutoAwesomeIcon />
          {title}
        </HeaderTitle>

        {buttonSlot}
      </HeaderTopRow>

      <HeaderSubtitle>{subtitleSlot}</HeaderSubtitle>

      {actionsSlotSlot && <HeaderActions>{actionsSlotSlot}</HeaderActions>}
      {tabsSlot && <HeaderTabs>{tabsSlot}</HeaderTabs>}
    </Header>
  );
};
